import loggerHelper from '../../loggerHelper';

let ctx = {};
let callbacks = {};
let ApplePaySession;
let applePayButtonSelector = null;
let applePayButtonContainer = null;
const applePayButtonTagName = 'apple-pay-button';

const init = (incomingCtx) => {
  const { sendMessageToMainIframe, createIframes, globalUserOptions, globalCallbacks } = incomingCtx;

  const {
    selectorForApplePayButton,
    applePayAmount,
    applePayCurrency,
    applePayCountryCode,
    applePayLabel,
    applePayButtonStyle,
    applePayButtonType,
    applePayButtonLocale
  } = globalUserOptions;

  ctx = {
    sendMessageToMainIframe,
    createIframes,
    globalUserOptions: {
      selectorForApplePayButton,
      applePayAmount,
      applePayCurrency,
      applePayCountryCode,
      applePayLabel,
      applePayButtonStyle,
      applePayButtonType,
      applePayButtonLocale
    }
  };

  callbacks = globalCallbacks;
};

const createApplePaySession = () => {
  ctx.sendMessageToMainIframe({ action: 'CREATE_APPLE_PAY_SESSION' });
}

const applePayJSLoadedPromise = (url) => new Promise((resolve, reject) => {
  const element = document.createElement('script');
  element.addEventListener('load', resolve, { once: true });
  element.addEventListener('error', reject);
  element.src = url;
  element.crossOrigin = 'anonymous';
  document.head.appendChild(element);
});

const applePayButtonEl = () => document.querySelector(applePayButtonSelector).querySelector(applePayButtonTagName);

const hideApplePayButton = () => {
  applePayButtonEl().style.display = 'none';
};

const showApplePayButton = () => {
  applePayButtonEl().style.display = 'inline-block';
};

const createApplePayButton = () => {
  const {
    selectorForApplePayButton,
    applePayButtonStyle,
    applePayButtonType,
    applePayButtonLocale
  } = ctx.globalUserOptions;
  applePayButtonSelector = selectorForApplePayButton;

  applePayButtonContainer = document.querySelector(applePayButtonSelector);
  const applePayButton = document.createElement(applePayButtonTagName);
  applePayButton.id = 'cfy-apple-pay-button';
  applePayButton.setAttribute('buttonstyle', applePayButtonStyle || 'black');
  applePayButton.setAttribute('type', applePayButtonType || 'pay');
  applePayButton.setAttribute('locale', applePayButtonLocale || 'en-US');
  applePayButton.style.display = 'none';

  applePayButtonContainer.appendChild(applePayButton);
};

const initApplePay = (data) => {
  if (ApplePaySession) {
    ApplePaySession.applePayCapabilities(data.merchantIdentifier).then((capabilities) => {
      if (capabilities.paymentCredentialStatus === 'applePayUnsupported') {
        callbacks.onApplePayNotSupported();
        loggerHelper.warn('This device is not capable of making Apple Pay payments.');
        return;
      } else {
        showApplePayButton();
        applePayButtonEl().addEventListener('click', (e) => handleClickApplePayButton(e, data));
      }
    });
  }
};

const handleClickApplePayButton = (e, data) => {
  e.preventDefault();

  const { applePayCountryCode, applePayAmount, applePayCurrency, applePayLabel } = ctx.globalUserOptions;
  const request = {
    countryCode: applePayCountryCode,
    currencyCode: applePayCurrency,
    supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
    merchantCapabilities: ['supports3DS'],
    total: { label: applePayLabel, amount: applePayAmount },
  }
  const session = new ApplePaySession(14, request);
  session.onvalidatemerchant = () => {
    try {
      session.completeMerchantValidation(data);
    } catch (error) {
      callbacks.onApplePayError(error);
      loggerHelper.error('Error validating merchant:', error);
      session.abort();
    }
  }
  session.onpaymentauthorized = (event) => {
    try {
      const token = btoa(JSON.stringify(event.payment.token.paymentData));
      session.completePayment(ApplePaySession.STATUS_SUCCESS);
      applePayTokenReceived(token);
      hideApplePayButton();
    } catch (error) {
      callbacks.onApplePayError(error);
      loggerHelper.error('Error tokenizing Apple Pay:', error);
      session.completePayment(ApplePaySession.STATUS_FAILURE);
    }
  };
  session.begin();
};

const applePaySessionCreated = async (data) => {
  await ctx.createIframes();

  createApplePayButton();

  applePayJSLoadedPromise(data.apple_pay_sdk_src).then(() => {
    if (window.ApplePaySession) {
      ApplePaySession = window.ApplePaySession;
    }
    initApplePay(data.session_data);
  }).catch((error) => loggerHelper.error('Failed to load Apple Pay JS SDK', error));
};

const applePayTokenReceived = (paymentMethodNonce) => {
  ctx.sendMessageToMainIframe({ action: 'APPLE_PAY_TOKEN_RECEIVED', data: paymentMethodNonce });
};

export default {
  init,
  createApplePaySession,
  applePaySessionCreated
};
